export function jitter(ms: number) {
  const random = crypto.getRandomValues(new Uint32Array(1))[0] / 0xffffffff;
  return ms * (0.88 + random * 0.24);
}
